import { render, staticRenderFns } from "./ModalUpdateShipment.vue?vue&type=template&id=62ced77a&scoped=true&"
import script from "./ModalUpdateShipment.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ced77a",
  null
  
)

export default component.exports